import styled from 'styled-components'

export const ContainerVisualizarModulosPermissoes = styled.div`
  width: 100%;
  height: calc(100% - 10px);
  box-sizing: border-box;
  padding: 5px;
  overflow: hidden;
`
export const ContainerBody = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
`
export const ContainerCards = styled.div`
  width: 100%;
  height: calc(100vh - 280px);
  padding: 5px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 20px;
  overflow-y: auto;
`
export const Card = styled.div`
  width: 32%;
  border: 2px solid #d9d9d9;
  border-radius: 10px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  background-color: #ffffff;
  box-sizing: border-box;
  transition: all 0.2s ease-in-out;

  .header__card {
    display: flex;
    justify-content: space-between;
  }

  .icone__perfil {
    display: flex;
    width: 100%;
    height: 100%;
    gap: 10px;
    align-items: center;
    justify-content: center;
  }

  .icone {
    width: 60px;
    height: 50px;
    border-radius: 10px;
    background-color: #eeeeee;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    color: #7b7b7b;
  }

  .nome__perfil {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    h3 {
      padding: 0;
      margin: 0;
      font-size: 14px;
      font-weight: bold;
      line-height: 20px;
      color: #5da57d;
    }

    span {
      padding: 0;
      margin: 0;
      font-size: 11px;
      font-weight: 500;
      color: #b4b4b4;
    }
  }

  &:hover {
    cursor: pointer;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease-in-out;
    transform: translateY(-2px);
  }
`

export const ContainerTags = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 10px;
  margin-top: 10px;

  .tag {
    width: fit-content;
    height: 30px;
    padding: 5px 10px;
    border-radius: 5px;
    background-color: #e5ffe4ff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 11px;
    color: #5da57d;
  }
`
